import { render, staticRenderFns } from "./confirm.template.vue?vue&type=template&id=0c57b806&scoped=true&"
var script = {}
import style0 from "./confirm.template.vue?vue&type=style&index=0&id=0c57b806&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c57b806",
  null
  
)

export default component.exports